export interface IEstimatePaths {
  estimates: {
    index: string;
    add: string;
    details: string;
    cloneRedirect: string;
  };
}

const paths: IEstimatePaths = {
  estimates: {
    index: '/estimates',
    add: '/estimates/add',
    details: '/estimates/:sheetId',
    cloneRedirect: '/estimates/clone/:id'
  }
};

export default paths;
